/**
 * The "you still have unsent notes" guard.
 *
 * Feedback givers annotate, then wander off — a link, a reload, a closed tab —
 * without ever pressing Send, and the notes are gone. `beforeunload` is the
 * one hook the browser gives us for that moment: while anything unsent
 * exists, the browser shows its own "Leave site?" dialog and the person can
 * stay and send. The dialog text is the browser's, not ours (modern browsers
 * ignore custom strings), so there is nothing to translate here.
 *
 * Silent when there is nothing to lose, so a visitor who never opened the
 * widget is never nagged.
 */
export function attachUnsavedGuard(hasUnsent: () => boolean): () => void {
  const onBeforeUnload = (event: BeforeUnloadEvent) => {
    if (!hasUnsent()) return
    event.preventDefault()
    // Legacy browsers key on returnValue; assigning any string arms the dialog.
    event.returnValue = ''
  }
  window.addEventListener('beforeunload', onBeforeUnload)
  return () => window.removeEventListener('beforeunload', onBeforeUnload)
}
